import { ChangeEvent, useEffect, useState } from 'react'
import style from '../../surveys.module.scss'
import Select from 'src/Components/Form/Select'
import TextArea from 'src/Components/Form/TextArea'
import { ISurveyStyles } from 'src/utils/Interfaces/survey.interface'
import Input from 'src/Components/Form/Input'
import Checkbox from 'src/Components/Form/Checkbox'

interface Props {
  data: ISurveyStyles
  update: (i: ISurveyStyles) => void
}

const StylesBlock = ({ data, update }: Props) => {
  const [styles, setStyles] = useState(data)
  const [updateBtn, setUpdateBtn] = useState(false)

  useEffect(() => {
    if (JSON.stringify(data) !== JSON.stringify(styles)) {
      setUpdateBtn(true)
    } else {
      setUpdateBtn(false)
    }
  }, [data, styles])

  return (
    <div className={style.styles_block}>
      <div>
        Horizontal position -
        <Select
          label="Value"
          light={true}
          list={['left', 'right']}
          value={styles.positionHorizontal}
          onChange={(e) => setStyles({ ...styles, positionHorizontal: e })}
        />
      </div>
      <div>
        Distance to side -
        <Input
          type="number"
          label="px"
          min="0"
          name="distance_to_side"
          value={styles.distanceToSide || ''}
          onChange={(e) => setStyles({ ...styles, distanceToSide: e.target.value })}
        />
      </div>
      <div>
        Animation -{' '}
        <input
          type="radio"
          name="animation"
          value="fade"
          checked={styles.animation === 'fade'}
          onChange={(e) => setStyles({ ...styles, animation: e.target.value as 'fade' })}
        />{' '}
        Fade
        <input
          type="radio"
          name="animation"
          value="slide"
          checked={styles.animation === 'slide'}
          onChange={(e) => setStyles({ ...styles, animation: e.target.value as 'slide' })}
        />{' '}
        Slide
        <input
          type="radio"
          name="animation"
          value="none"
          checked={!styles.animation}
          onChange={() => setStyles({ ...styles, animation: undefined })}
        />{' '}
        None
      </div>
      <div>
        Powered by -
        <Checkbox
          name="powered_by"
          checked={styles.poweredBy ?? false}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setStyles({ ...styles, poweredBy: e.target.checked })}
        />
      </div>
      <div>
        Question color -
        <input
          type="color"
          name="question_color"
          value={styles.questionColor ?? ''}
          onChange={(e) => setStyles({ ...styles, questionColor: e.target.value })}
        />
      </div>
      <div>
        Answer color -
        <input
          type="color"
          name="answer_color"
          value={styles.answerColor ?? ''}
          onChange={(e) => setStyles({ ...styles, answerColor: e.target.value })}
        />
      </div>
      <div>
        Submit color -
        <input
          type="color"
          name="submit_color"
          value={styles.submitBgColor ?? ''}
          onChange={(e) => setStyles({ ...styles, submitBgColor: e.target.value })}
        />
      </div>
      <div>
        Submit text color -
        <input
          type="color"
          name="submit_text_color"
          value={styles.submitTextColor ?? ''}
          onChange={(e) => setStyles({ ...styles, submitTextColor: e.target.value })}
        />
      </div>
      <div>
        Background color -
        <input
          type="color"
          name="background_color"
          value={styles.bgMainColor ?? ''}
          onChange={(e) => setStyles({ ...styles, bgMainColor: e.target.value })}
        />
      </div>
      <div>
        Background min color -
        <input
          type="color"
          name="background_close_color"
          value={styles.bgCloseColor ?? ''}
          onChange={(e) => setStyles({ ...styles, bgCloseColor: e.target.value })}
        />
      </div>
      <div>
        Text min color -
        <input
          type="color"
          name="text_close_color"
          value={styles.textCloseColor ?? ''}
          onChange={(e) => setStyles({ ...styles, textCloseColor: e.target.value })}
        />
      </div>
      <div>
        Submit text -
        <Input
          label="Text"
          name="submit_text"
          value={styles.submitText ?? ''}
          onChange={(e) => setStyles({ ...styles, submitText: e.target.value })}
        />
      </div>
      <div>
        Textarea placeholder -
        <Input
          label="Text"
          name="textarea_placeholder"
          value={styles.textareaPlaceholder ?? ''}
          onChange={(e) => setStyles({ ...styles, textareaPlaceholder: e.target.value })}
        />
      </div>
      <div>
        <TextArea
          label="Custom style"
          name="custom_style"
          value={styles.customStyle ?? ''}
          onChange={(e) => setStyles({ ...styles, customStyle: e.target.value })}
        />
      </div>
      {updateBtn && (
        <button className="btn" onClick={() => update(styles)}>
          Update
        </button>
      )}
    </div>
  )
}

export default StylesBlock
